import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Globe2, ArrowLeft } from 'lucide-react';
import ReactMarkdown from 'react-markdown';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function LegalPage() {
  const { type } = useParams();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const section = type === 'privacy' ? 'privacy_policy' : 'terms_of_service';
    axios.get(`${API}/api/site-content`).then(r => {
      const data = r.data?.[section];
      setContent(data || {});
    }).catch(() => setContent({})).finally(() => setLoading(false));
    window.scrollTo(0, 0);
  }, [type]);

  const title = type === 'privacy' ? 'Məxfilik Siyasəti' : 'İstifadə Şərtləri';

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="w-10 h-10 border-4 border-[#0077B6] border-t-transparent rounded-full animate-spin" /></div>;

  return (
    <div className="min-h-screen bg-[#F4F7F6]">
      <div className="bg-[#03045E] text-white py-12">
        <div className="max-w-4xl mx-auto px-6">
          <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-4 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Əsas Səhifəyə qayıt
          </Link>
          <div className="flex items-center gap-3">
            <Globe2 className="w-8 h-8 text-[#00B4D8]" />
            <h1 className="text-3xl font-bold">{title}</h1>
          </div>
          {content?.updated_at && <p className="text-white/40 text-sm mt-2">Son yenilənmə: {content.updated_at}</p>}
        </div>
      </div>
      <div className="max-w-4xl mx-auto px-6 py-12">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-2xl p-8 md:p-12 border border-[#E2E8F0] shadow-sm">
          <div className="legal-content">
            <ReactMarkdown components={{
              h1: ({children}) => <h1 className="text-2xl font-bold text-[#03045E] mb-4 mt-6 first:mt-0">{children}</h1>,
              h2: ({children}) => <h2 className="text-xl font-bold text-[#03045E] mb-3 mt-8 border-b border-[#E2E8F0] pb-2">{children}</h2>,
              h3: ({children}) => <h3 className="text-lg font-semibold text-[#1A2530] mb-2 mt-6">{children}</h3>,
              p: ({children}) => <p className="text-[#1A2530] text-sm leading-relaxed mb-4">{children}</p>,
              ul: ({children}) => <ul className="list-disc pl-6 mb-4 space-y-1">{children}</ul>,
              li: ({children}) => <li className="text-[#1A2530] text-sm leading-relaxed">{children}</li>,
              strong: ({children}) => <strong className="font-semibold text-[#03045E]">{children}</strong>,
              a: ({href, children}) => <a href={href} className="text-[#0077B6] hover:underline">{children}</a>,
            }}>{content?.content || 'Məzmun hələ əlavə edilməyib.'}</ReactMarkdown>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
